import React ,{ 
    createContext, 
    useCallback, 
    useContext, 
    useState,
    useEffect,
    useMemo
} from 'react';
import AxiosInstance from '../../server/AxioInstance';
import { useSnackbar } from './index'

// Criando o contexto
const AuthContext = createContext();

// Hook customizado para utilizar o contexto
export const useAuth = () => useContext(AuthContext);

// Provedor do contexto que englobará sua aplicação
export const AuthProvider = ({ children }) => {
    const { showSnackbar } = useSnackbar();
    const [accessToken, setAccessToken] = useState(undefined);
    const token = localStorage.getItem('@gedy:token');
    const user = localStorage.getItem('@gedy:user');

    useEffect(() => {
        if (token && user) {
            setAccessToken({ token, user});
        } else {
            setAccessToken(undefined);
        }
        // eslint-disable-next-line
    }, []);

    // Função para realizar o login e armazenar o token
    const handleLogin = useCallback( async (login, password) => {
        try{
            const result = await AxiosInstance.post('/login/authentication', {user:login, password:password})

            const token = result?.data?.token;
            const user = result?.data?.user;
            const group = result?.data?.id_group;

            localStorage.setItem('@gedy:token', token);
            localStorage.setItem('@gedy:user', user);
            localStorage.setItem('@gedy:group', group);

            AxiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;

            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Login feito com sucesso',
                variant: 'success',
            });

            setAccessToken({ token, user});
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error?.response?.data?.msg,
                variant: 'error',
            });
        }
        // eslint-disable-next-line
    }, []);

     // Função para realizar o logout e limpar o token
    const handleLogout = useCallback(() => {
        localStorage.removeItem('@gedy:token');
        localStorage.removeItem('@gedy:user');
        setAccessToken(undefined);
        // eslint-disable-next-line
    }, []);

    // Função para verificar a validade do token
    const checkTokenValidity = useCallback(async () => {
        try {
            await AxiosInstance.post('/validation/check-token-validity', {token: localStorage.getItem('@gedy:token')});
        } catch (error) {
            console.error('Erro ao verificar a validade do token:', error);
            handleLogout();
        }
        // eslint-disable-next-line
    }, [handleLogout]);

    // Verifica se o usuário está autenticado
    const isAuthenticated = useMemo(() => !! accessToken, [accessToken]);

    // Dados que serão fornecidos pelo contexto
    const contextValue = {
        token,
        login: handleLogin,
        logon: handleLogout,
        isAuthenticated,
        checkTokenValidity,
    };

    // Retorna o provedor do contexto com os dados necessários
    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};
